/**
 * Kolaysoft Arşivi arama planı.
 * Arşivin tamamını indirmemek için arama metni tek bir Firestore sorgusuna çevrilir.
 */

/** Arşivdeki searchTokens ile aynı katlama (scripts/kolaysoft-archive.cjs → fold) */
export const foldArchiveText = (s) =>
  String(s || '')
    .replace(/[ıİ]/g, 'i')
    .replace(/[şŞ]/g, 's')
    .replace(/[ğĞ]/g, 'g')
    .replace(/[üÜ]/g, 'u')
    .replace(/[öÖ]/g, 'o')
    .replace(/[çÇ]/g, 'c')
    .toLowerCase()
    .replace(/[^a-z0-9 ]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();

/**
 * Dönem seçimi tek ay ('2026-10') veya ay listesi (['2026-05', …]) olabilir.
 * Liste hâli "Son 6 Ay" için; Firestore `in` sorgusu en fazla 30 değer alır,
 * 6 ay sınırın çok altında.
 */
const donemPlani = (month) =>
  Array.isArray(month)
    ? { kind: 'months', value: month[month.length - 1] || '', values: [...month] }
    : { kind: 'month', value: month };

/**
 * Arama metnini sorgu planına çevirir.
 * @returns {{ kind: 'month'|'months'|'tc'|'no'|'name', value: string, values?: string[], words?: string[] }}
 */
export const resolveArchiveSearch = (text, month) => {
  const raw = String(text || '').trim();
  if (!raw) return donemPlani(month);
  const digits = raw.replace(/\D/g, '');
  if (/^\d[\d\s]*$/.test(raw) && (digits.length === 10 || digits.length === 11)) {
    return { kind: 'tc', value: digits };
  }
  // MMS = e-Arşiv serisi, MMD = e-Fatura serisi
  if (/^mm[sd]\d{4,}/i.test(raw.replace(/\s/g, ''))) {
    return { kind: 'no', value: raw.replace(/\s/g, '').toUpperCase() };
  }
  const words = foldArchiveText(raw).split(' ').filter((w) => w.length >= 2);
  if (!words.length) return donemPlani(month);
  const longest = [...words].sort((a, b) => b.length - a.length)[0];
  return { kind: 'name', value: longest, words };
};
